import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import CustomerDetailPageHeader from '@/components/pages/Customer/Detail/PageHeader'
import CustomerDetailTable from '@/components/pages/Customer/Detail/Table'

import { useCustomers } from './Customers.hooks'

const CustomerDetail = () => {
  const { id } = useParams()

  const { customer, getCustomerDetail, getCustomersLoading } = useCustomers()

  useEffect(() => {
    getCustomerDetail(Number(id))
  }, [getCustomerDetail, id])

  return (
    <>
      <CustomerDetailPageHeader />
      <CustomerDetailTable
        {...{
          dataSource: customer,
          getCustomersLoading,
        }}
      />
    </>
  )
}

CustomerDetail.displayName = 'CustomerDetail'
export default CustomerDetail
